/**
 * @generated SignedSource<<fe5f1dde025cc75f365a9b2a599e9d0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsPlusInlinePaywall$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsPlusArticle" | "helpersGetArticleTypeArticle">;
  readonly " $fragmentType": "helpersIsPlusInlinePaywall";
};
export type helpersIsPlusInlinePaywall$key = {
  readonly " $data"?: helpersIsPlusInlinePaywall$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsPlusInlinePaywall">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsPlusInlinePaywall"
};

(node as any).hash = "7b0e961cf710a4d91c416f0ae2e60a54";

export default node;
